import { ActivatedRouteSnapshot } from '@angular/router';
import * as fromFreezeBlock from '@app/root-store/ui/freeze-block';
import * as fromRouter from '@app/root-store/router';

import { Store, select } from '@ngrx/store';
import { map, filter, combineLatest } from 'rxjs/operators';
import { Observable, combineLatest as rxCombineLatest } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class FreezeBlockGuard  {

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return rxCombineLatest([
      this.store$.pipe(select(fromFreezeBlock.selectBlockedEdition)),
      this.store$.pipe(select(fromFreezeBlock.selectUserHasWriteAccessPermission))
    ]).pipe(
      filter(([blockedEdition, hasWriteAccess]) => blockedEdition !== null && hasWriteAccess !== null),
      map(([blockedEdition, hasWriteAccess]) => {
        if (blockedEdition && !hasWriteAccess) {
          this.store$.dispatch(fromRouter.go({ path: '/', queryParams: {} }));
          return false;
        }
        return true;
      })
    );
  }

  constructor(
    private store$: Store<fromFreezeBlock.State>
  ) {}
}
